import { render, staticRenderFns } from "./ChangeSizeAndTestDialog.vue?vue&type=template&id=4720d652&scoped=true&"
import script from "./ChangeSizeAndTestDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeSizeAndTestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4720d652",
  null
  
)

export default component.exports